// import DataTable from '@/containers/data_table_ml/DataTable';
import { history } from 'umi';
import React from 'react';
import { useIntl } from 'umi';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import { IconButton } from '@material-ui/core';
import { useTheme } from '@material-ui/core';
import DataTableNativeML from '@/components/DataTableNativeML';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import TablePageStyled from './TablePageStyled.jsx';
import { fmtThousand } from '@/utils/comUtil';
const TablePage = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const theme = useTheme();
  const { pagination, total, loading, tableData, setPageData } = props || {};
  const handleToGoodDetail = (record, status, sourceOid) => {
    history.push({
      pathname:
        status === 'edit'
          ? '/integral/gift_exchange_record/gift_exchange_record_form_edit'
          : '/integral/gift_exchange_record/gift_exchange_record_form_detail',
      query: {
        opt: status === 'edit' ? 'edit' : 'detail',
        id: String(record.id),
        sourceOid,
      },
    });
  };

  const columns = [
    {
      align: 'center',
      title: '礼品订单编号',
      width: 260,
      id: 'orderNo',
      key: 'orderNo',
    },
    {
      title: '会员号',
      align: 'center',
      id: 'memberCode',
      key: 'memberCode',
      width: 180,
    },
    {
      title: '会员姓名',
      id: 'memberName',
      key: 'memberName',
      width: 100,
      align: 'center',
    },
    // {
    //   title: '领取方式',
    //   id: 'giftReceiveMethod',
    //   key: 'giftReceiveMethod',
    //   width: 140,
    //   align: 'center',
    // },
    {
      title: '礼品标题',
      id: 'giftTitle',
      key: 'giftTitle',
      width: 140,
      align: 'center',
    },
    {
      title: '货架ID',
      id: 'shelfId',
      key: 'shelfId',
      width: 140,
      align: 'center',
    },
    {
      title: '货架名称',
      id: 'shelfName',
      key: 'shelfName',
      width: 140,
      align: 'center',
    },
    {
      title: '兑换状态',
      id: 'status',
      key: 'status',
      width: 140,
      align: 'center',
    },
    {
      title: '礼品类型',
      id: 'giftType',
      key: 'giftType',
      width: 100,
      align: 'center',
      render: ({ giftType }) => {
        return giftType === '实物' ? '实物邮寄' : giftType;
      },
    },
    {
      title: '消耗积分',
      id: 'exchangePoints',
      key: 'exchangePoints',
      width: 100,
      align: 'center',
    },
    {
      title: '消耗金额',
      id: 'exchangeCost',
      key: 'exchangeCost',
      width: 100,
      align: 'center',
      render: (item) => {
        return item.exchangeCost !== null
          ? fmtThousand(item.exchangeCost, 2, true)
          : '-';
      },
    },
    {
      title: '邮费',
      id: 'postageAmount',
      key: 'postageAmount',
      width: 100,
      align: 'center',
      render: (item) => {
        const number =
          item.postageAmount !== null ? item.postageAmount.toFixed(2) : null;
        return number !== null ? fmtThousand(number, 2, true) : '-';
      },
    },
    {
      title: '收件人手机号',
      id: 'mobile',
      key: 'mobile',
      width: 200,
      align: 'center',
    },
    {
      title: '兑换时间',
      id: 'exchangeTime',
      key: 'exchangeTime',
      width: 200,
      align: 'center',
    },
    {
      title: '总单号',
      id: 'masterOrderNo',
      key: 'masterOrderNo',
      width: 200,
      align: 'center',
    },
    {
      title: formatMessage({ id: 'item.gift.c01.lbl11' }),
      width: 200,
      align: 'center',
      render: (recor) => {
        const canEdit =
          recor.giftType === '实物' &&
          (recor.status === '已发货' ||
            recor.status === '已购买' ||
            recor.status === '已兑换');
        return (
          <div align="center" className={'handle_btn'}>
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.03' })}>
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_point_mall_exchange_record_list_edit',
                  events: ['_ev', '_ec'],
                  params: {
                    exchange_id: recor.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() =>
                  handleToGoodDetail(
                    recor,
                    'edit',
                    'btn_point_mall_exchange_record_list_edit',
                  )
                }
                disabled={!canEdit}
              >
                <SvgIconML
                  name="edit"
                  size={24}
                  fill={
                    canEdit
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.05' })}>
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_point_mall_exchange_record_list_details',
                  events: ['_ev', '_ec'],
                  params: {
                    exchange_id: recor.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                className=""
                onClick={() =>
                  handleToGoodDetail(
                    recor,
                    'detail',
                    'btn_point_mall_exchange_record_list_details',
                  )
                }
              >
                <SvgIconML
                  name="detail"
                  size={24}
                  fill={theme.palette.primary.main}
                  // fill={'#1B60AD'}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
          </div>
        );
      },
    },
  ];
  return (
    <TablePageStyled>
      <DataTableNativeML
        loading={loading}
        paging={true}
        total={total}
        columns={columns}
        page={pagination}
        changePage={(pageObj) => {
          setPageData(pageObj);
        }}
        data={tableData}
        columnKey="id"
      ></DataTableNativeML>
    </TablePageStyled>
  );
};
export default TablePage;
